import { Space } from 'antd'
import { useImplicitPermissions } from '../../../../../../../ImplicitPermissionViewer/hooks/useImplicitPermissions'
import { CIMSTags } from 'components/CIMSTags'
import { CIMSTag } from 'components/CIMSTag'
import { RoleTagsUser } from './types'
import { useUsersTableContext } from '../../../../../../UsersTableContext'
import { dateFormatter } from 'utils/dateFormatter'

export const RoleTags: React.VFC<RoleTagsUser> = (user) => {
  const { customFields } = useUsersTableContext()
  const { implicitRoles } = useImplicitPermissions({ user, customFields })
  const {
    roles,
    permissions,
    developer,
    developerDate,
    developerGrantedBy,
    admin,
  } = user
  return (
    // Adding the 'Additional Permissions' tag to CIMSTags sorts it to first
    <Space size={'small'} direction="vertical">
      <CIMSTags
        tags={roles?.map(({ name, description }) => ({
          text: name,
          tooltip: description,
        }))}
      />
      {!!admin && (
        <CIMSTag
          tooltip={`Granted by ${
            admin.lastEditedUser
          } on ${dateFormatter.datetime(admin.lastEditedDate)}`}
          color="purple"
        >
          Project Admin
        </CIMSTag>
      )}
      {developer && (
        <CIMSTag
          tooltip={`Granted by ${
            developerGrantedBy?.username
          } on ${dateFormatter.datetime(developerDate)}`}
          color="purple"
        >
          Developer
        </CIMSTag>
      )}
      {!!permissions.length && (
        <CIMSTag tooltip={permissions.length.toString()} color="blue">
          Additional Permissions
        </CIMSTag>
      )}
      {!admin && !developer && (
        <CIMSTags
          tags={(implicitRoles ?? []).map((name) => ({
            text: name,
            color: 'orange',
          }))}
        />
      )}
    </Space>
  )
}
